export function FooterDisclaimer(): JSX.Element {
  return (
    <footer className="mt-12 border-t border-border bg-panel">
      <div className="mx-auto max-w-5xl px-4 py-6 text-xs text-muted leading-relaxed">
        <p>
          Informational only. Odds shown are aggregated from Polymarket and Kalshi public market
          data. LadderBook does not place wagers on your behalf and is not a sportsbook or
          regulated exchange. 18+. Markets may be unavailable in some jurisdictions.
        </p>
        <nav className="mt-3 flex flex-wrap gap-x-4 gap-y-1">
          <a href="/legal/terms" className="hover:text-text">Terms</a>
          <a href="/legal/privacy" className="hover:text-text">Privacy</a>
          <a href="/profile" className="hover:text-text">Profile</a>
        </nav>
      </div>
    </footer>
  );
}
